<script setup lang="ts">
import { computed } from 'vue';
import { UiButton } from '@shopexperts/shared';

interface Props {
  currentStep: number;
  totalSteps: number;
  isLoading?: boolean;
  nextLabel?: string;
  backLabel?: string;
}

const props = withDefaults(defineProps<Props>(), {
  isLoading: false,
  nextLabel: 'Continue',
  backLabel: 'Back',
});

const emit = defineEmits<{
  (e: 'back'): void;
  (e: 'next'): void;
}>();

const showBackButton = computed(() => props.currentStep > 1);
const isLastStep = computed(() => props.currentStep === props.totalSteps);
const buttonLabel = computed(() => {
  if (props.nextLabel) return props.nextLabel;
  return isLastStep.value ? 'Submit' : 'Continue';
});
</script>

<template>
  <div class="flex items-center gap-4 pt-6">
    <!-- Back button -->
    <UiButton
      v-if="showBackButton"
      type="button"
      variant="outline"
      :label="backLabel"
      :disabled="isLoading"
      @click="emit('back')"
    />
    
    <!-- Spacer when no back button -->
    <div v-else class="flex-1" />
    
    <!-- Next/Submit button -->
    <UiButton
      type="submit"
      variant="primary"
      :label="buttonLabel"
      :disabled="isLoading"
      class="flex-1"
    />
  </div>
</template>

